import { Observable, Subject } from 'rxjs';

export class DrawerCloseService extends Observable<unknown> {
  private readonly closeSubject = new Subject<void>();

  public constructor() {
    super(subscriber => this.closeSubject.subscribe(subscriber));
  }

  public close(): void {
    this.closeSubject.next();
    this.closeSubject.complete();
  }
}
